var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.resource.chatRoomId)?_c('chat',{attrs:{"resource":_vm.resource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }